import { AccrualCodes } from "pages/web/accruals/subpages/accrual_codes/AccrualCodes";
import { AccrualDates } from "pages/web/accruals/subpages/accrual_dates/AccrualDates";
import { AccrualProfiles } from "pages/web/accruals/subpages/accrual_profiles/AccrualProfiles";
import { AccrualRules } from "pages/web/accruals/subpages/accrual_rules/AccrualRules";
import { BalanceDomino } from "pages/web/accruals/subpages/balance_domino/BalanceDomino";
import { GroupBalance } from "pages/web/accruals/subpages/group_balance/GroupBalance";
import { DatePatterns } from "pages/web/accruals/subpages/date_patterns/DatePatterns";
import { Grants } from "pages/web/accruals/subpages/grants/Grants";
import { Limits } from "pages/web/accruals/subpages/limits/Limits";
import { Resume } from "pages/web/accruals/subpages/resume/Resume";

const gettingSubPage = (subPage: string) => {
    switch (subPage) {
        case 'resume':
            return <Resume />;

        case 'accrual_codes':
            return <AccrualCodes />;

        case 'accrual_dates':
            return <AccrualDates />;

        case 'date_pattern':
            return <DatePatterns />;

        case 'accrual_profiles':
            return <AccrualProfiles />;

        case 'accrual_rules':
            return <AccrualRules />;

        case 'balance_domino':
            return <BalanceDomino />;

        case 'group_balance':
            return <GroupBalance />;

        case 'grants':
            return <Grants />;

        case 'limits':
            return <Limits />;

        default:
            return <> {`404 Subpage ${subPage} not found`} </>
    }
}

export { gettingSubPage };